import { TaskType } from '@shared/enums/task-type.enum';
export const sortListByGroup = (_list: any[] = []) => {
  const list = Array.isArray(_list) ? _list : [];
  const group = list.reduce((r, a) => {
    r[a.type] = [...(r[a.type] || []), a];
    return r;
  }, {} as Record<string, any[]>);
  Object.keys(group).forEach((key) => (group[key] = group[key].sort((a, b) => a?.sortOrder - b?.sortOrder)));
  const orders = [
    TaskType.TYPE_NOTE,
    TaskType.TYPE_TASK,
    TaskType.TYPE_CORRECTION,
    TaskType.TYPE_CHANGE,
    TaskType.TYPE_ORDER,
    'documentation',
    'finance',
    'control',
    'message',
  ];
  let sortedList: any[] = [];
  orders.forEach((type: TaskType | string) => (sortedList = sortedList.concat((group[type] || []).filter(Boolean))));

  Object.keys(group)
    .filter((key) => !orders.includes(key))
    .forEach((key) => {
      sortedList = sortedList.concat((group[key] || []).filter(Boolean));
    });

  return sortedList;
};
